/**
 * Preferência “sempre só ícones” no Two Column (LAC-190).
 * Por quê: localStorage por conta/usuário — não precisa de API; hamburger continua
 * abrindo a 2ª coluna só enquanto a rota não muda.
 */

export type TwoColumnShellScope = "tenant" | "sa";

const EVENT = "brenvio:twocolumn-always-icons-updated";

function readSessionUserId(storageKey: string): string | null {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    const id = parsed?.user?.id ?? parsed?.id;
    return id != null ? String(id) : null;
  } catch {
    return null;
  }
}

function readTenantId(): string | null {
  try {
    const raw = sessionStorage.getItem("authUser");
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    const id = parsed?.tenant?.id ?? parsed?.user?.tenant_id;
    return id != null ? String(id) : null;
  } catch {
    return null;
  }
}

/** Chave por shell + conta + usuário (troca de login não herda preferência alheia). */
export function alwaysIconsStorageKey(scope: TwoColumnShellScope): string {
  if (scope === "sa") {
    const userId = readSessionUserId("sa_authUser") ?? "anon";
    return `brenvio:twocolumn-always-icons:sa:${userId}`;
  }
  const tenantId = readTenantId() ?? "anon";
  const userId = readSessionUserId("authUser") ?? "anon";
  return `brenvio:twocolumn-always-icons:tenant:${tenantId}:${userId}`;
}

export function readAlwaysIconsOnly(scope: TwoColumnShellScope): boolean {
  try {
    return localStorage.getItem(alwaysIconsStorageKey(scope)) === "1";
  } catch {
    return false;
  }
}

export function writeAlwaysIconsOnly(
  scope: TwoColumnShellScope,
  enabled: boolean
): void {
  try {
    localStorage.setItem(alwaysIconsStorageKey(scope), enabled ? "1" : "0");
  } catch {
    // private mode / quota — preferência só desta sessão via evento abaixo
  }
  window.dispatchEvent(
    new CustomEvent(EVENT, { detail: { scope, enabled } })
  );
}

export function toggleAlwaysIconsOnly(scope: TwoColumnShellScope): boolean {
  const next = !readAlwaysIconsOnly(scope);
  writeAlwaysIconsOnly(scope, next);
  return next;
}

export function subscribeAlwaysIconsOnly(
  listener: () => void
): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
